module.exports = __webpack_public_path__ + "img/2.ff9dc0eb.gif";